import {h} from 'preact';
import PropTypes from 'prop-types';

/**
 * @jsx h Tell babel to use h for JSX
 * @return {JSX.Element}
 * @constructor
 */
export default function MobileLayout({children}) {
  return (
    <div className="Avada_PreviewMobile__Screen">
      <div className="Avada_PreviewMobile__Inline">{children}</div>
    </div>
  );
}

MobileLayout.propTypes = {
  children: PropTypes.any
};
